import controller from './tunnel.controller';
import templateBase from './templates/tunnel-base.view.html';
import templateAD from './templates/tunnel-view-adaptative.html';

let TunnelComponent = {
    template:changeTemplate ,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');
    if(__env.adaptative){
        return templateAD;
    } else {  
        return templateBase;
    }
}

export default TunnelComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/tunnel/tunnel.component.js
 **/